import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Image,
  Input,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  message,
  Spin,
  InputRef,
  Collapse,
  Switch,
  TreeSelect,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetNoticeById,
  GetPreDraft,
  UpdateNotice,
} from "../../../services/NoticeService";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  GetAllCategories,
  GetCategoryById,
  GetCategorySelectListVm,
} from "../../../services/CategoryService";
import CategoryNotice from "./CategoryNotice";
import {
  CameraOutlined,
  DeleteFilled,
  DeleteOutlined,
  ExportOutlined,
  FileExcelOutlined,
  MinusSquareOutlined,
  PaperClipOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { lightGreen } from "@mui/material/colors";
import { Units, Vats } from "../../../helpers/Units";
import {
  AddNoticeDetailsService,
  RemoveNoticeDetailsService,
} from "../../../services/NoticeDetailsService";
import { read, utils, writeFile } from "xlsx";
import {
  DeleteFileById,
  GetCover,
  GetFileById,
  GetFilesEntityId,
  UploadImage,
} from "../../../services/MediumService";
import imageCompression from "browser-image-compression";
import axios from "axios";
import { GURL } from "../../../services/global";
import {
  AddNoticeLevelService,
  GetNoticeLevelsByNoticeId,
  RemoveNoticeLevelService,
} from "../../../services/NoticeLevelsService";
import toast from "react-hot-toast";
import userEvent from "@testing-library/user-event";
import { PanoramaSharp } from "@mui/icons-material";
import CustomButton from "../../share/customButton";
import { ColorPalette } from "../../share/color/colorPalette";
import TedWhitePlus from "../../icons/ManageNotice/TedWhitePlus";
import TedDelIcon from "../../icons/ManageNotice/TedDelIcon";

import CustomLabel from "../../share/customLabel";
import { GetMyCompanyAddresses } from "../../../services/AddressService";

const ManageNoticeV3 = () => {
  const navigate = useNavigate();
  const [getNoticeId, setNoticeId] = useState<any>(null);
  const [getNoticeCategory, setNoticeCategory] = useState<any>();
  const [getNoticeExprirationDays, setNoticeExprirationDays] = useState<any>();
  const [getNoticeForceSupply, setNoticeForceSupply] = useState<any>();

  const [getNoticeMainTitleValid, setNoticeMainTitleValid] = useState(true);
  const [getNoticeDetails, setNoticeDetails] = useState<any>([]);
  const [GetAllCategoriesData, SetAllCategoriesData] = useState<any>(null);

  const params = useParams();

  //Component Mount

  useEffect(() => {
    console.log("GetAllCategoriesData", GetAllCategoriesData);
  }, [GetAllCategoriesData]);

  const convertToTreeData = (data: any) => {
    return [
      ...data.map((item: any) => ({
        label: item.title,
        value: item.id,
      })),
    ];
  };

  const [getMyAddresses, setMyAddresses] = useState<any>([]);

  useEffect(() => {
    GetMyCompanyAddresses().then((p) => {
      // console.log("addr", p.data.data);

      setMyAddresses(convertToTreeData(p?.data?.data));
    });
    GetCategorySelectListVm().then((p) => {
      console.log("cate", p.data.data);

      SetAllCategoriesData(p?.data?.data);
    });
    if (params.id) {
      GetNoticeById(params.id).then((p) => {
        console.log("new dr", p.data);

        if (p.data) {
          formik.setFieldValue("title", p.data.title);
          formik.setFieldValue("id", p.data.id);
          formik.setFieldValue("categoryId", p.data.categoryId);
          formik.setFieldValue("noticeType", p.data.noticeType);
          formik.setFieldValue("description", p.data.description);
          setNoticeCategory(p?.data?.categoryId);
          setNoticeExprirationDays(p?.data?.expirationDays);
          SetNoticeLevels(p?.data?.noticeLevels);
          setNoticeForceSupply(p?.data?.forceSupply);
          const updatedNoticeDetails = p?.data?.noticeDetails?.map(
            (notice: any) => ({
              ...notice,
              savedInDb: true,
              prepareNewRecord: false,
            })
          );
          const emptyNoticeDetails: any = [
            {
              order: 0,
              title: "",
              count: 1,
              unit: 1,
              vat: "0.1",
              forceSupply: true,
              savedInDb: false,
              prepareNewRecord: false,
            },
            {
              order: 0,
              title: "",
              count: 1,
              unit: 1,
              vat: "0.1",
              forceSupply: true,
              savedInDb: true,
              prepareNewRecord: true,
            },
          ];

          console.log("updatedNoticeDetails", updatedNoticeDetails);

          setNoticeId(p.data.id);
          console.log(emptyNoticeDetails);

          setNoticeDetails([...updatedNoticeDetails, ...emptyNoticeDetails]);
        }
        if (
          p.data.categoryId === null ||
          p.data === "" ||
          p.data === undefined
        ) {
          setShowCategoriesPanel(true);
          setIsLoading(false);
        } else {
          GetCategoryById(p.data.categoryId).then((p) => {
            //setNoticeCategory(p.data);
            setShowCategoriesPanel(false);
            setIsLoading(false);
          });
        }
      });
    } else {
      GetPreDraft().then((p) => {
        console.log("new dr", p.data);

        if (p.data) {
          formik.setFieldValue("title", p.data.title);
          formik.setFieldValue("id", p.data.id);
          formik.setFieldValue("categoryId", p.data.categoryId);
          formik.setFieldValue("noticeType", p.data.noticeType);
          formik.setFieldValue("description", p.data.description);
          setNoticeCategory(p?.data?.categoryId);
          setNoticeExprirationDays(p?.data?.expirationDays);
          SetNoticeLevels(p?.data?.noticeLevels);
          setNoticeForceSupply(p?.data?.forceSupply);
          const updatedNoticeDetails = p?.data?.noticeDetails?.map(
            (notice: any) => ({
              ...notice,
              savedInDb: true,
              prepareNewRecord: false,
            })
          );
          const emptyNoticeDetails: any = [
            {
              order: 0,
              title: "",
              count: 1,
              unit: 1,
              vat: "0.1",
              forceSupply: true,
              savedInDb: false,
              prepareNewRecord: false,
            },
            {
              order: 0,
              title: "",
              count: 1,
              unit: 1,
              vat: "0.1",
              forceSupply: true,
              savedInDb: true,
              prepareNewRecord: true,
            },
          ];

          console.log("updatedNoticeDetails", updatedNoticeDetails);

          setNoticeId(p.data.id);
          console.log(emptyNoticeDetails);
          if (updatedNoticeDetails) {
            setNoticeDetails([...updatedNoticeDetails, ...emptyNoticeDetails]);
          }
        }
        if (
          p.data.categoryId === null ||
          p.data === "" ||
          p.data === undefined
        ) {
          setShowCategoriesPanel(true);
          setIsLoading(false);
        } else {
          GetCategoryById(p.data.categoryId).then((p) => {
            //setNoticeCategory(p.data);
            setShowCategoriesPanel(false);
            setIsLoading(false);
          });
        }
        setIsLoading(false); // added 03/07/28
      });
    }
    setIsLoading(false); // added 03/07/28
  }, []);
  //End Component DidMount

  const [getShowCategoriesPanel, setShowCategoriesPanel] = useState(true);

  //Spinner for low internet

  const [getIsLoading, setIsLoading] = useState(true);
  const contentStyle: React.CSSProperties = {
    padding: 50,
    borderRadius: 4,
  };
  const content = <div style={contentStyle} />;

  //End Spinner for low internet

  //Formik
  const formik = useFormik({
    initialValues: {
      id: null,
      files: [],
      categoryId: null,
      description: "",
      image: "",
      noticeType: 0,
      title: "",
      positionId: null,
    },
    validationSchema: Yup.object().shape({
      files: Yup.array().required("لطفا فایل را وارد کنید"),
      description: Yup.string().required("لطفا توضیحات را وارد نمایید"),
      title: Yup.string().required("لطفا عنوان آگهی را وارد نمایید"),
    }),
    onSubmit: async (values) => {
      console.log(values);
    },
  });
  //End Formik

  const handleCategoryChange = (newData: any) => {
    setNoticeCategory(newData);
    setShowCategoriesPanel(false);
  };
  async function ChangeContentAsync(body: any) {
    if (getNoticeId) {
      await UpdateNotice({
        noticeId: getNoticeId,
        key: body.key,
        value: body.value.toString(),
      });
    } else {
      console.log("some thing get wrong with getPreDraft");
    }
  }

  //Validations Start
  const [getCountIsValid, setCountIsValid] = useState(true);
  const [getTitleIsValid, setTitleIsValid] = useState(true);
  const [getNoticeLevelIsValid, setNoticeLevelIsValid] = useState(true);

  //Validations End

  //Hanlde Paste start
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData.getData("text");
    if (!/^\d+$/.test(paste)) {
      e.preventDefault();
    }
  };

  //Hanlde Paste End
  const titleInputRef = useRef<InputRef>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const focusableElements = Array.from(
        document.querySelectorAll<HTMLElement>(
          'input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => !el.hasAttribute("disabled"));

      const currentIndex = focusableElements.indexOf(e.target as HTMLElement);
      const nextElement = focusableElements[currentIndex + 1];

      if (nextElement) {
        nextElement.focus();
      }
    }
  };

  //Columns Of Table
  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "4%",
      align: "center",
      render: (item, record, index) => (
        <>
          {record.prepareNewRecord ? (
            <>
              <PlusSquareOutlined
                onClick={() => handleAddNoticeDetailAndAddNewRow(index)}
                style={{ color: "green", fontSize: "1.5rem" }}
              />
            </>
          ) : (
            <> {index + 1} </>
          )}
        </>
      ),
    },
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",

      width: "30%",
      align: "center",
      render: (item, record, index) => (
        <div style={{ display: record.prepareNewRecord ? "none" : "block" }}>
          {record.savedInDb ? (
            <>{record.title} </>
          ) : (
            <>
              <Input
                id="title"
                name="title"
                ref={titleInputRef}
                //onPaste={handlePaste}
                value={
                  getUnSavedNoticeDetails["title"] === undefined
                    ? ""
                    : getUnSavedNoticeDetails["title"]
                }
                onBlur={(e) => {
                  if (e.target.value === "" || e.target.value.trim() === "") {
                    setTitleIsValid(false);
                    e.target.focus();
                  } else {
                    setTitleIsValid(true);
                  }
                }}
                onKeyDown={handleKeyDown}
                onChange={SetUnSavedNoticeDetailsInfo}
                className="p-2"
                placeholder="عنوان"
                status={getTitleIsValid ? "" : "error"}
              />
            </>
          )}
        </div>
      ),
    },
    {
      title: "مقدار",
      dataIndex: "count",
      key: "count",

      width: "10%",
      align: "center",

      render: (item, record, index) => (
        <div style={{ display: record.prepareNewRecord ? "none" : "block" }}>
          {record.savedInDb ? (
            <>{record.count} </>
          ) : (
            <>
              <Input
                onKeyDown={handleKeyDown}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                id="count"
                name="count"
                onChange={SetUnSavedNoticeDetailsInfo}
                value={
                  getUnSavedNoticeDetails["count"] === undefined
                    ? ""
                    : getUnSavedNoticeDetails["count"]
                }
                className="p-2"
                placeholder="مقدار"
                onBlur={(e) => {
                  if (
                    e.target.value === "0" ||
                    e.target.value === "" ||
                    e.target.value.trim() === ""
                  ) {
                    setCountIsValid(false);
                    e.target.focus();
                  } else {
                    setCountIsValid(true);
                  }
                }}
                status={getCountIsValid ? "" : "error"}
                onPaste={handlePaste}
                //value={record.count}
                //status={formik.touched.title && formik.errors.title ? "error" : ""}
              />{" "}
            </>
          )}
        </div>
      ),
    },
    {
      title: "واحد",
      dataIndex: "unit",
      key: "unit",

      width: "15%",
      align: "center",
      render: (item, record, index) => (
        <div style={{ display: record.prepareNewRecord ? "none" : "block" }}>
          {record.savedInDb ? (
            <>
              {record.unit == "1" && <label>عدد</label>}
              {record.unit == "2" && <label>گرم</label>}
              {record.unit == "3" && <label>کیلوگرم</label>}
              {record.unit == "4" && <label>لیتر</label>}
              {record.unit == "5" && <label>متر</label>}
              {record.unit == "6" && <label>دستگاه</label>}{" "}
              {record.unit == "7" && <label>شاخه</label>}{" "}
              {record.unit == "8" && <label>بسته</label>}{" "}
              {record.unit == "9" && <label>پرس</label>}{" "}
              {record.unit == "10" && <label>متر مکعب</label>}{" "}
            </>
          ) : (
            <>
              <Select
                onKeyDown={handleKeyDown}
                style={{ width: 120 }}
                //onChange={handleChange}
                options={Units}
                defaultValue="1"
                id="unit"
                value={
                  getUnSavedNoticeDetails["unit"] === undefined
                    ? Units[0]
                    : Units[
                        Units.findIndex(
                          (f: any) =>
                            f.value === getUnSavedNoticeDetails["unit"]
                        )
                      ]?.label
                }
                onChange={(e) =>
                  SetUnSavedNoticeDetailsInfo({
                    target: { id: "unit", value: e },
                  })
                }
              />
            </>
          )}
        </div>
      ),
    },
    {
      title: "ارزش افزوده",
      dataIndex: "noticeState",
      key: "noticeState",
      width: "7%",
      align: "center",
      render: (item, record, index) => (
        <div style={{ display: record.prepareNewRecord ? "none" : "block" }}>
          {record.savedInDb ? (
            <> {record.vat} </>
          ) : (
            <>
              <Input
                onKeyDown={handleKeyDown}
                id="vat"
                name="vat"
                onChange={SetUnSavedNoticeDetailsInfo}
                value={
                  getUnSavedNoticeDetails["vat"] === undefined
                    ? parseFloat("0.1")
                    : getUnSavedNoticeDetails["vat"]
                }
                className="p-2"
                placeholder=""
                //value={record.vat}
                //status={formik.touched.title && formik.errors.title ? "error" : ""}
              />
            </>
          )}
        </div>
      ),
    },
    {
      title: "تامین کامل",
      dataIndex: "noticeState",
      key: "noticeState",
      width: "6%",
      align: "center",
      render: (item, record, index) => (
        <div style={{ display: record.prepareNewRecord ? "none" : "block" }}>
          {record.savedInDb ? (
            <>
              <Checkbox
                checked={record.forceSupply}
                id="forceSupply"
                disabled
                //onChange={SetSelectedNoticeDetailsInfo}
              />
            </>
          ) : (
            <>
              <Checkbox
                onKeyPress={(e) => {
                  console.log(e.key);

                  if (e.key === "Enter") {
                    handleAddNoticeDetailAndAddNewRow(index);
                  }
                }}
                checked={
                  getUnSavedNoticeDetails["forceSupply"] === false
                    ? false
                    : true
                }
                id="forceSupply"
                onChange={SetUnSavedNoticeDetailsInfo}
              />
            </>
          )}
        </div>
      ),
    },
    {
      title: "عملیات",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "5%",
      align: "center",
      render: (item, record, index) => (
        <div
          style={{
            display:
              record.prepareNewRecord === false && record.savedInDb === true
                ? "block"
                : "none",
          }}
        >
          <Tooltip title="حذف">
            <Popconfirm
              title="آیا از حذف ردیف مطمئن هستید؟"
              okText="بله"
              cancelButtonProps={{
                className: "ant-btn-primary ant-btn-dangerous",
                style: {
                  color: "black",
                },
              }}
              cancelText="خیر"
              onConfirm={() => removeNoticeDetail(record.id, record.title)}
            >
              <a>
                <DeleteFilled />
              </a>
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];
  //End Columns OF Table

  const [getUnSavedNoticeDetails, setUnSavedNoticeDetails] = useState({
    order: 0,
    title: "",
    count: 1,
    unit: "1",
    vat: "0.1",
    addressId: "",
    forceSupply: true,
    savedInDb: false,
    prepareNewRecord: false,
  });

  const SetUnSavedNoticeDetailsInfo = (e: any) => {
    console.log(e);

    if (e.target.id === "title") {
      const value = e.target.value;
      if (value.trim() === "") {
        setTitleIsValid(false);
      } else {
        setTitleIsValid(true);
      }
    }
    if (e.target.id === "forceSupply") {
      setUnSavedNoticeDetails({
        ...getUnSavedNoticeDetails,
        ["forceSupply"]: e.target.checked,
      });
    } else if (e.target.id === "vat") {
      setUnSavedNoticeDetails({
        ...getUnSavedNoticeDetails,
        ["vat"]: (parseFloat(e.target.value) / 100).toString(),
      });
    } else {
      setUnSavedNoticeDetails({
        ...getUnSavedNoticeDetails,
        [e.target.id]: e.target.value,
      });
    }

    //console.log("GetSelectedNoticeDetails", GetSelectedNoticeDetails);
  };

  useEffect(() => {
    console.log("01", getNoticeDetails);

    if (getUnSavedNoticeDetails["savedInDb"]) {
      console.log(2);

      const firstUnsavedIndex = getNoticeDetails.findIndex(
        (notice: any) =>
          notice.savedInDb === false || notice.prepareNewRecord === true
      );
      console.log("firstUnsavedIndex in getNoticeDetails", firstUnsavedIndex);
      if (firstUnsavedIndex !== -1) {
        setNoticeDetails((prevNoticeDetails: any) =>
          prevNoticeDetails.filter(
            (notice: any) =>
              notice.savedInDb !== false && notice.prepareNewRecord === false
          )
        );
      } else {
        console.log(22);
        setUnSavedNoticeDetails({
          order: 0,
          title: "",
          count: 1,
          unit: "1",
          vat: "0.1",
          addressId: "",
          forceSupply: true,
          savedInDb: false,
          prepareNewRecord: false,
        });
      }
    }
  }, [getNoticeDetails]);

  useEffect(() => {
    if (getUnSavedNoticeDetails["savedInDb"]) {
      setNoticeDetails([...getNoticeDetails, getUnSavedNoticeDetails]);
    } else {
      const firstUnsavedIndex = getNoticeDetails.findIndex(
        (notice: any) =>
          notice.savedInDb === false || notice.prepareNewRecord === true
      );
      console.log("firstUnsavedIndex", firstUnsavedIndex);

      if (firstUnsavedIndex === -1) {
        const emptyNoticeDetails: any = [
          {
            order: 0,
            title: "",
            count: 1,
            unit: 1,
            vat: "0.1",
            forceSupply: true,
            savedInDb: false,
            prepareNewRecord: false,
          },
          {
            order: 0,
            title: "",
            count: 1,
            unit: 1,
            vat: "0.1",
            forceSupply: true,
            savedInDb: true,
            prepareNewRecord: true,
          },
        ];

        setNoticeDetails([...getNoticeDetails, ...emptyNoticeDetails]);
      }
    }
  }, [getUnSavedNoticeDetails]);

  const removeNoticeDetail = async (id: any, title: any) => {
    console.log("pdata-getnoticeId", id);

    await RemoveNoticeDetailsService(id, getNoticeId)
      .then((p) => {
        console.log("pdata-RemovalData", p.data);

        if (p.data.statusCode == 200) {
          //console.log(id);
          //console.log(getNoticeDetails);

          setNoticeDetails((current: any) =>
            current.filter((o: any) => o.title != title)
          );
        }
      })
      .then(() => {
        setNoticeDetails((current: any) =>
          current.filter((o: any) => o.id != id)
        );
      });
  };

  const [getIsSaving, setIsSaving] = useState(true);
  const handleAddNoticeDetailAndAddNewRow = async (index: any) => {
    if (
      getTitleIsValid === false ||
      getCountIsValid === false ||
      getUnSavedNoticeDetails.title === ""
    ) {
      setTitleIsValid(false);
      message.error("موارد خواسته شده را پر کنید");

      return;
    }
    setIsLoading(true);
    await AddNoticeDetailsService(
      getUnSavedNoticeDetails.forceSupply,
      getNoticeDetails.filter((f: any) => f.title !== "").length + 1,
      getUnSavedNoticeDetails.title,
      getUnSavedNoticeDetails.count,
      getUnSavedNoticeDetails.unit,
      getUnSavedNoticeDetails.vat,
      getUnSavedNoticeDetails.addressId,
      getNoticeId
    ).then((res) => {
      if (res.data.statusCode == 200) {
        console.log("pdata-datadromdb", res.data);
        console.log("resres", res);

        const updatedNoticeDetails = res?.data?.data?.noticeDetails?.map(
          (notice: any) => ({
            ...notice,
            savedInDb: true,
            prepareNewRecord: false,
          })
        );
        const emptyNoticeDetails: any = [
          {
            order: 0,
            title: "",
            count: 1,
            unit: 1,
            vat: "0.1",
            forceSupply: true,
            savedInDb: false,
            prepareNewRecord: false,
          },
          {
            order: 0,
            title: "",
            count: 1,
            unit: 1,
            vat: "0.1",
            forceSupply: true,
            savedInDb: true,
            prepareNewRecord: true,
          },
        ];

        console.log(emptyNoticeDetails);
        console.log("updatedNoticeDetails", updatedNoticeDetails);

        setNoticeDetails([...updatedNoticeDetails, ...emptyNoticeDetails]);

        //return;
        setIsLoading(false);
        setUnSavedNoticeDetails({
          order: 0,
          title: "",
          count: 1,
          unit: "1",
          vat: "0.1",
          addressId: "",
          forceSupply: true,
          savedInDb: false,
          prepareNewRecord: false,
        });
      }
    });
  };

  // import Data from Excel

  interface DataType {
    id?: string;
    noticeId: string;
    order: number;
    title: string;
    unit: number;
    vat: number;
    addressId: string;
    count: number;
    forceSupply: boolean;
    savedInDB?: boolean;
  }
  const [file, setFile] = useState<File | null>(null);
  const [errorInImportExcel, setErrorInImportExcel] = useState(false);

  const importToGridByExcel = (event: React.ChangeEvent<HTMLInputElement>) => {
    // console.log("DDDDD");

    let files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const allowedExtensions = [".xlsx", ".xls", ".csv"];
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (!allowedExtensions.includes(`.${fileExtension}`)) {
        message.error("فایل انتخاب شده می بایست از نوع اکسل باشد.");
        return;
      }

      console.log(file);
      setFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        let hasError: boolean = false;

        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const workbook = read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const excelData: any = utils.sheet_to_json(workbook.Sheets[sheetName]);
        console.log(excelData);

        let tempImportedRow: DataType[] = [];
        let importedObject: DataType;

        if (!errorInImportExcel) {
          const checkedOrders = new Set();

          for (const row of excelData) {
            let unitNum: number = 0;

            //map units to number
            switch (row.واحد) {
              case "عدد":
                unitNum = 1;
                break;
              case "گرم":
                unitNum = 2;
                break;
              case "کیلوگرم":
              case "کیلو گرم":
                unitNum = 3;
                break;
              case "لیتر":
                unitNum = 4;
                break;
              case "متر":
                unitNum = 5;
                break;
              case "دستگاه":
                unitNum = 6;
                break;
              case "شاخه":
                unitNum = 7;
                break;
              case "بسته":
                unitNum = 8;
                break;
              case "پرس":
                unitNum = 9;
                break;
              case "متر مکعب":
                unitNum = 10;
                break;
            }

            if (row.عنوان === undefined || typeof row.عنوان !== "string") {
              message.error(
                "ستون عنوان وجود ندارد یا از نوع رشته ای نمی باشد."
              );
              hasError = true;
            }

            if (
              row.مقدار === undefined ||
              typeof row.مقدار !== "number" ||
              row.مقدار < 0
            ) {
              message.error("ستون مقدار وجود ندارد یا از نوع عددی نمی باشد.");
              hasError = true;
            }

            if (row.واحد === undefined || typeof row.واحد !== "string") {
              message.error("ستون واحد وجود ندارد یا از نوع رشته ای نمی باشد.");
              hasError = true;
            }

            if (
              row["واحد"] !== "عدد" &&
              row["واحد"] !== "گرم" &&
              row["واحد"] !== "کیلوگرم" &&
              row["واحد"] !== "کیلو گرم" &&
              row["واحد"] !== "لیتر" &&
              row["واحد"] !== "متر" &&
              row["واحد"] !== "دستگاه" &&
              row["واحد"] !== "شاخه" &&
              row["واحد"] !== "بسته" &&
              row["واحد"] !== "پرس" &&
              row["واحد"] !== "متر مکعب"
            ) {
              message.error(
                `ستون واحد، مقادیر عدد،گرم،کیلوگرم،لیتر و متر را قبول می کند. مقدار اشتباه: (${row.واحد}).`
              );
              hasError = true;
            }

            if (
              row["ارزش افزوده"] === undefined ||
              typeof row["ارزش افزوده"] !== "number" ||
              row["ارزش افزوده"] < 0
            ) {
              message.error(
                "ستون ارزش افزوده وجود ندارد یا از نوع عددی نمی باشد."
              );
              hasError = true;
            }

            if (
              row["تامین کامل"] === undefined ||
              typeof row["تامین کامل"] !== "boolean"
            ) {
              message.error(
                "ستون تامین کامل وجود ندارد یا از نوع بولی (0 یا 1) نمی باشد."
              );
              hasError = true;
            }

            event.target.value = "";

            importedObject = {
              order: 0,
              title: row.عنوان,
              count: row.مقدار,
              unit: unitNum,
              vat: row["ارزش افزوده"],
              addressId: "",
              forceSupply: row["تامین کامل"],
              noticeId: getNoticeId,
            };

            if (!hasError) {
              tempImportedRow.push(importedObject);
            }

            hasError = false;
          }
        }

        const processItems = async () => {
          let newOrder = getNoticeDetails.length - 1;

          for (const item of tempImportedRow) {
            // console.log("newRowData in item in map excel", item);

            item.order = newOrder;
            setIsLoading(true);
            await AddNoticeDetailsService(
              item.forceSupply,
              item.order,
              item.title,
              item.count,
              item.unit,
              item.vat,
              item.addressId,
              item.noticeId
            ).then((p) => {
              if (p.data.statusCode == 200) {
                setIsLoading(false);
                setUnSavedNoticeDetails({
                  order: item.order,
                  title: item.title,
                  count: item.count,
                  unit: item.unit.toString(),
                  vat: item.vat.toString(),
                  addressId: item.addressId.toString(),
                  forceSupply: item.forceSupply,
                  savedInDb: true,
                  prepareNewRecord: false,
                });
              }
            });

            newOrder++;
          }
        };

        processItems();
      };
      reader.readAsArrayBuffer(file);
    }
  };
  const excelSampleRows: DataType[] = [
    {
      id: "a6e1ba84-9830-4c53-c54c-08dc6756bf65",
      noticeId: "29e2e4a0-c608-415b-9476-08dc46589f7e",
      order: 1,
      title: "آچار فرانسه",
      unit: 1,
      vat: 0.1,
      addressId: "",
      count: 5,
      forceSupply: true,
    },
  ];
  const [excelSample, setExcelSample] = useState<DataType[]>(excelSampleRows);

  const handleSampleExcel = () => {
    // Create a new workbook
    const workbook = utils.book_new();

    // Create a new worksheet
    const worksheet = utils.json_to_sheet(
      excelSample.map((row: DataType) => ({
        عنوان: row.title,
        مقدار: row.count,
        واحد: "عدد",
        "ارزش افزوده": row.vat,
        "تامین کامل": row.forceSupply,
      }))
    );

    // Add the worksheet to the workbook
    utils.book_append_sheet(workbook, worksheet, "AdvertisementQty");

    writeFile(workbook, "sampleData.xlsx");
  };

  ///Another

  const [GetNoticeCover, SetNoticeCover] = useState<any>(null);
  const [GetNoticeCoverView, SetNoticeCoverView] = useState<any>(null);

  async function ImageUpload(Base64Image: any) {
    if (
      getNoticeId !== null &&
      getNoticeId !== undefined &&
      getNoticeId !== ""
    ) {
      await UploadImage({
        entityId: getNoticeId,
        entityNameId: "92697E5B-2DBC-43B6-860B-FA8A29941059",
        medium: Base64Image,
      }).then((p) => {
        if (p.data.statusCode == 200) {
          SetNoticeCoverView(Base64Image);
        }
      });
    }
  }
  async function handleDownload(id: any, fileName: any) {
    await GetFileById(id)
      .then((response) => {
        console.log(response);

        // Create a blob object from the response
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();

        // Clean up
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        // Handle download error
      });
  }
  async function handleCapture(event: any) {
    console.log("FF");

    const file = event.target.files[0];
    const options = {
      maxSizeMB: 1024,
      maxWidthOrHeight: 2048,
      useWebWorker: true,
      fileType: "image/jpeg",
      initialQuality: 1.0,
    };
    const compressedFile = await imageCompression(file, options);
    // console.log(
    // 	"compressedFile instanceof Blob",
    // 	compressedFile instanceof Blob
    // ); // true

    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    const reader = new FileReader();

    reader.readAsDataURL(compressedFile);
    reader.onloadend = async function () {
      const base64data = reader.result;
      console.log(base64data);

      SetNoticeCover(base64data);
    };
  }

  useEffect(() => {
    ImageUpload(GetNoticeCover);
    SetNoticeCoverView(GetNoticeCover);
  }, [GetNoticeCover]);

  async function GetCoverAsync() {
    if (!getNoticeId) return;
    await GetCover({
      entityId: getNoticeId,
      entityNameId: "92697E5B-2DBC-43B6-860B-FA8A29941059",
    }).then((p) => {
      if (p.data) {
        console.log("cover", p.data);

        SetNoticeCoverView(p.data);
      }
    });
  }
  useEffect(() => {
    if (
      getNoticeId !== null &&
      getNoticeId !== "" &&
      getNoticeId !== undefined
    ) {
      GetCoverAsync();
      GetFilesAsync(getNoticeId);
    }
  }, [getNoticeId]);

  //End

  /* Files Start */
  const [FileLoaded, SetFileLoded] = useState<any>(null);
  const [FileLoadedView, SetFileLoadedView] = useState<any>(null);

  const [File1, SetFile1] = useState<any>(null);

  useEffect(() => {
    if (File1) {
      const formData = new FormData();
      formData.append("file", File1);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(
          `${GURL}/Medium/v1/MediumFile/Upload?noticeId=${getNoticeId}`,
          formData,
          config
        )
        .then((response) => {
          GetFilesAsync(getNoticeId);
        })
        .catch((error) => {
          // Handle errors
        });
    }
  }, [File1]);

  async function GetFilesAsync(noticeId: any) {
    await GetFilesEntityId(noticeId).then((p) => {
      SetFileLoded(p.data.data);
      console.log("Files", p.data.data);
    });
  }

  useEffect(() => {
    console.log("FileLoaded", FileLoaded);
    SetFileLoadedView(FileLoaded);
    SetFile1(null);
    console.log("File1 in File Loaded", File1);
  }, [FileLoaded]);

  /* Files End */
  //Start NoticeLevels
  function dynamicSort(property: any) {
    return function (a: any, b: any) {
      return a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    };
  }
  const [GetSelectedNoticeLevels, SetSelectedNoticeLevels] = useState({
    noticeLevelName: "",
  });
  const [GetNoticeLevels, SetNoticeLevels] = useState([]);
  const SetSelectedNoticeLevelInfo = (e: any) => {
    if (e.target.id === "noticeLevelName") {
      const value = e.target.value;
      if (value.trim() === "") {
        setNoticeLevelIsValid(false);
      } else {
        setNoticeLevelIsValid(true);
      }
    }

    SetSelectedNoticeLevels({
      ...GetSelectedNoticeLevels,
      [e.target.name]: e.target.value,
    });

    //console.log("GetSelectedNoticeDetails", GetSelectedNoticeDetails);
  };
  const addNoticeLevel = (id: any) => {
    // id.persist();
    // id.preventDefault();
    //console.log("GetSelectedNoticeLevels", GetSelectedNoticeLevels);
    if (GetSelectedNoticeLevels.noticeLevelName.trim() === "") {
      setNoticeLevelIsValid(false);
      message.error("لطفا موارد خواسته شده را پر کنید");
      return;
    } else {
      setNoticeLevelIsValid(true);
    }
    if (getNoticeLevelIsValid === false) {
      message.error("لطفا موارد خواسته شده را پر کنید");
      return;
    }
    AddNoticeLevelService(
      GetNoticeLevels.length + 1,
      GetSelectedNoticeLevels.noticeLevelName,
      getNoticeId
    )
      .then((p) =>
        GetNoticeLevelsByNoticeId(getNoticeId).then((a) =>
          SetNoticeLevels(a.data.data)
        )
      )
      .then(() =>
        SetSelectedNoticeLevels({
          noticeLevelName: "",
        })
      );
    SetSelectedNoticeLevels({
      noticeLevelName: "",
    });
  };

  const removeNoticeLevel = (id: any) => {
    RemoveNoticeLevelService(id, getNoticeId).then((p) =>
      GetNoticeLevelsByNoticeId(getNoticeId).then((d) =>
        SetNoticeLevels(d.data.data)
      )
    );
    // SetNoticeLevels((current: any) => current.filter((o: any) => o.id !== id));
  };
  //End NoticeLevels

  return (
    <div className="container mt-5">
      {getIsLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "100vh",
            alignItems: "center",
          }}
        >
          <Spin fullscreen tip="درحال بارگذاری" size="large">
            {content}
          </Spin>
        </div>
      ) : (
        <>
          <Row style={{ borderBottom: "1px solid gray", height: "45px" }}>
            <Col
              style={{
                fontFamily: "YekanBakhVF",
                fontWeight: "600",
                fontSize: "28px",
                lineHeight: "28px",
                color: ColorPalette.gray[800],
              }}
            >
              اطلاعات کل آگهی
            </Col>
          </Row>
          <Card className="mt-3">
            <Row
              style={{
                height: "37px",
              }}
            >
              <Col>
                <Switch
                  checked={getNoticeForceSupply}
                  id="forceSupply"
                  onChange={async (e) => {
                    setNoticeForceSupply(e);
                    await ChangeContentAsync({
                      key: "forceSupply",
                      value: e,
                    });
                  }}
                />

                <span
                  className="mx-2"
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontSize: "18px",
                    fontWeight: "325",

                    color: ColorPalette.gray[900],
                  }}
                >
                  تامین همه اقلام
                </span>
              </Col>
            </Row>
            <Row className="display-flex align-items-center my-2 mt-2">
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    نوع دسته بندی را مشخص کنید
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TreeSelect
                      showSearch
                      style={{
                        width: 610,
                        height: "40px",
                        fontFamily: "YekanBakhVF",
                        fontWeight: "325",
                        fontSize: "16px",
                        lineHeight: "28.8px",
                      }}
                      value={getNoticeCategory}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      placeholder="دسته مورد نظر را انتخاب کنید"
                      //allowClear
                      //treeDefaultExpandAll
                      onChange={async (e) => {
                        //alert(e);
                        setNoticeCategory(e);
                        await ChangeContentAsync({
                          key: "categoryid",
                          value: e,
                        });
                      }}
                      treeData={GetAllCategoriesData}
                      filterTreeNode={(input: any, node: any) =>
                        node.title.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                    {/* <Select
                          //onChange={handleChange}

                          defaultValue="1"
                          id="unit"
                          value={"انتخاب کنید"}
                          onChange={(e) =>
                            SetUnSavedNoticeDetailsInfo({
                              target: { id: "unit", value: e },
                            })
                          }
                        /> */}
                  </Col>
                </Row>
              </Col>
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    یک عنوان برای آگهی خود اختصاص دهید
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      style={{
                        width: "610px",
                        height: "40px",
                        fontFamily: "YekanBakhVF",
                        fontWeight: "325",
                        fontSize: "16px",
                        lineHeight: "28.8px",
                      }}
                      id="title"
                      {...formik.getFieldProps("title")}
                      className="p-2"
                      status={
                        formik.touched.title && formik.errors.title
                          ? "error"
                          : ""
                      }
                      // onPaste={handlePaste}
                      onBlur={async (e) => {
                        formik.handleBlur(e);
                        if (formik.errors.title) {
                          //e.target.focus();
                        } else {
                          await ChangeContentAsync({
                            key: "title",
                            value: e.target.value,
                          });
                        }
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row style={{ marginTop: "16px" }}>
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    شرح
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextArea
                      style={{
                        height: "92px",
                        width: "1234px",
                        fontFamily: "YekanBakhVF",
                        fontWeight: "325",
                        fontSize: "16px",
                        lineHeight: "28.8px",
                      }}
                      id="description"
                      {...formik.getFieldProps("description")}
                      rows={6}
                      status={
                        formik.touched.description && formik.errors.description
                          ? "error"
                          : ""
                      }
                      onBlur={async (e) => {
                        formik.handleBlur(e);
                        if (formik.errors.description) {
                          // e.target.focus();
                        } else {
                          await ChangeContentAsync({
                            key: "description",
                            value: e.target.value,
                          });
                        }
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="display-flex align-items-center my-2 mt-3">
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    فرآیند آگهی
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Select
                      style={{
                        width: 610,
                        height: "40px",
                        fontFamily: "YekanBakhVF",
                        fontWeight: "325",
                        fontSize: "16px",
                        lineHeight: "28.8px",
                      }}
                      //onChange={handleChange}

                      defaultValue="1"
                      id="unit"
                      value={"انتخاب فرآیند"}
                      onChange={(e) =>
                        SetUnSavedNoticeDetailsInfo({
                          target: { id: "unit", value: e },
                        })
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    مدت اعتبار آگهی{" "}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Select
                      style={{
                        width: 610,
                        height: "40px",
                        fontFamily: "YekanBakhVF",
                        fontWeight: "325",
                        fontSize: "16px",
                        lineHeight: "28.8px",
                      }}
                      //onChange={handleChange}
                      options={[
                        { value: "1", label: <span>یک روز</span> },
                        { value: "2", label: <span>دو روز</span> },
                        { value: "3", label: <span>سه روز</span> },
                        { value: "7", label: <span>یک هفته</span> },
                        { value: "14", label: <span>دو هفته</span> },
                        { value: "21", label: <span>سه هفته</span> },
                        { value: "30", label: <span>یک ماه</span> },
                      ]}
                      id="ExprirationDays"
                      value={
                        getNoticeExprirationDays?.toString() === "0"
                          ? "انتخاب کنید"
                          : getNoticeExprirationDays?.toString()
                      }
                      onChange={async (e) => {
                        setNoticeExprirationDays(e);
                        //return;
                        await ChangeContentAsync({
                          key: "ExprirationDays",
                          value: e,
                        });
                      }}
                      // onChange={(e) =>
                      //   SetUnSavedNoticeDetailsInfo({
                      //     target: { id: "ExprirationDays", value: e },
                      //   })
                      // }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Card className="mt-3">
            <Row>
              <Col>
                <label
                  htmlFor="file-input"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    id="file-input"
                    type="file"
                    accept=".xlsx, .xls ,.csv"
                    onChange={importToGridByExcel}
                    style={{ display: "none" }}
                  />
                  <CustomButton
                    style={{
                      width: "196px",
                      height: "48px",
                      border: "1px solid",
                      backgroundColor: ColorPalette.primaryBlue[50],
                      borderColor: ColorPalette.primaryBlue[600],
                      color: ColorPalette.primaryBlue[600],
                    }}
                    hasTitle
                    customType="Secondary"
                    onClick={() =>
                      document.getElementById("file-input")?.click()
                    }
                  >
                    ورود اطلاعات با فایل اکسل
                  </CustomButton>
                </label>
              </Col>
              <Col className="mx-2">
                <CustomButton
                  style={{
                    width: "196px",
                    height: "48px",
                    border: "1px solid",
                    backgroundColor: ColorPalette.primaryBlue[50],
                    borderColor: ColorPalette.primaryBlue[600],
                    color: ColorPalette.primaryBlue[600],
                  }}
                  hasTitle
                  customType="Secondary"
                  onClick={handleSampleExcel}
                >
                  دانلود نمونه فایل اکسل
                </CustomButton>
              </Col>
            </Row>
          </Card>
          <Card className="my-3">
            {getNoticeDetails
              .filter((f: any) => f.title !== "")
              .map((p: any) => {
                return (
                  <Row className="mt-1" style={{}}>
                    <Collapse
                      style={{
                        width: "100%",

                        backgroundColor: "#ABD5FF1F",
                        fontFamily: "YekanBakhVF",
                      }}
                      collapsible="header"
                      items={[
                        {
                          key: p.id,
                          label: (
                            <div
                              style={{
                                height: "40px",
                                width: "1200px",
                                color: ColorPalette.primaryBlue[800],
                                fontSize: "18px",
                                fontWeight: "600",
                                lineHeight: "32.4px",
                                display: "flex",
                              }}
                            >
                              <div style={{ width: "97%" }}>{p.title}</div>
                              <div>
                                <Tooltip title="حذف">
                                  <Popconfirm
                                    title="آیا از حذف ردیف مطمئن هستید؟"
                                    okText="بله"
                                    cancelButtonProps={{
                                      className:
                                        "ant-btn-primary ant-btn-dangerous",
                                      style: {
                                        color: "black",
                                      },
                                    }}
                                    cancelText="خیر"
                                    onConfirm={(e: any) => {
                                      removeNoticeDetail(p.id, p.noticeId);
                                      e.stopPropagation();
                                    }}
                                  >
                                    <a>
                                      <TedDelIcon />
                                    </a>
                                  </Popconfirm>
                                </Tooltip>
                              </div>
                            </div>
                          ),

                          children: (
                            <div>
                              <Row
                                style={{
                                  height: "37px",
                                }}
                              >
                                <Col>
                                  <Switch checked={p.forceSupply} disabled />
                                  <span
                                    className="mx-2"
                                    style={{
                                      fontFamily: "YekanBakhVF",
                                      fontSize: "18px",
                                      fontWeight: "325",

                                      color: ColorPalette.gray[900],
                                    }}
                                  >
                                    تامین همه اقلام
                                  </span>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col style={{ margin: "auto" }}>
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      عنوان{" "}
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "600px",
                                          height: "40px",
                                          fontFamily: "YekanBakhVF",
                                          fontWeight: "325",
                                          fontSize: "16px",
                                          lineHeight: "28.8px",
                                        }}
                                        disabled
                                        value={p.title}
                                        className="p-2"
                                      />
                                    </Col>
                                  </Row>
                                </Col>

                                <Col style={{ margin: "auto" }}>
                                  <Row
                                    style={{
                                      height: "37px",
                                    }}
                                  >
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      ارزش افزوده(درصد)
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "600px",
                                          height: "40px",
                                          fontFamily: "YekanBakhVF",
                                          fontWeight: "325",
                                          fontSize: "16px",
                                          lineHeight: "28.8px",
                                        }}
                                        value={Math.round(
                                          parseFloat(p.vat) * 100
                                        )}
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col style={{ margin: "auto" }}>
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      مقدار
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "600px",
                                          height: "40px",
                                        }}
                                        value={p.count}
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                </Col>

                                <Col style={{ margin: "auto" }}>
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      واحد
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Input
                                        style={{
                                          width: "600px",
                                          height: "40px",
                                        }}
                                        disabled
                                        value={
                                          p.unit == "1"
                                            ? "عدد"
                                            : p.unit == "2"
                                            ? "گرم"
                                            : p.unit == "3"
                                            ? "کیلوگرم"
                                            : p.unit == "4"
                                            ? "لیتر"
                                            : p.unit == "5"
                                            ? "متر"
                                            : p.unit == "6"
                                            ? "دستگاه"
                                            : p.unit == "7"
                                            ? "شاخه"
                                            : p.unit == "8"
                                            ? "بسته"
                                            : p.unit == "9"
                                            ? "پرس"
                                            : p.unit == "10"
                                            ? "متر مکعب"
                                            : ""
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="display-flex align-items-center my-2 mt-2">
                                <Col style={{ margin: "auto" }}>
                                  <Row style={{ height: "37px" }}>
                                    <Col
                                      style={{
                                        fontFamily: "YekanBakhVF",
                                        fontWeight: "325",
                                        fontSize: "16px",
                                        lineHeight: "28.8px",
                                        color: ColorPalette.gray[950],
                                      }}
                                    >
                                      آدرس
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col style={{ width: "75.2rem" }}>
                                      <Select
                                        disabled
                                        onKeyDown={handleKeyDown}
                                        style={{
                                          width: "100%",
                                          height: "40px",
                                        }}
                                        placeholder="انتخاب از آدرس های فروشگاه"
                                        options={getMyAddresses}
                                        value={p.addressId}
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </Row>
                );
              })}
          </Card>
          <Card className="mt-3">
            <Row
              style={{
                height: "37px",
              }}
            >
              <Col>
                <Switch
                  checked={
                    getUnSavedNoticeDetails["forceSupply"] === false
                      ? false
                      : true
                  }
                  id="forceSupply"
                  onChange={(e) =>
                    SetUnSavedNoticeDetailsInfo({
                      target: { id: "forceSupply", checked: e },
                    })
                  }
                />

                <span
                  className="mx-2"
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontSize: "18px",
                    fontWeight: "325",

                    color: ColorPalette.gray[900],
                  }}
                >
                  تامین کامل
                </span>
              </Col>
            </Row>
            <Row className="display-flex align-items-center my-2 mt-2">
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    عنوان
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      style={{ width: "610px", height: "40px" }}
                      id="title"
                      name="title"
                      ref={titleInputRef}
                      //onPaste={handlePaste}
                      value={
                        getUnSavedNoticeDetails["title"] === undefined
                          ? ""
                          : getUnSavedNoticeDetails["title"]
                      }
                      onBlur={(e) => {
                        if (
                          e.target.value === "" ||
                          e.target.value.trim() === ""
                        ) {
                          setTitleIsValid(false);
                          e.target.focus();
                        } else {
                          setTitleIsValid(true);
                        }
                      }}
                      onKeyDown={handleKeyDown}
                      onChange={SetUnSavedNoticeDetailsInfo}
                      className="p-2"
                      status={getTitleIsValid ? "" : "error"}
                    />
                  </Col>
                </Row>
              </Col>

              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    ارزش افزوده(درصد)
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Select
                      onKeyDown={handleKeyDown}
                      style={{ width: 610, height: "40px" }}
                      //onChange={handleChange}

                      options={Vats}
                      defaultValue="10"
                      id="vat"
                      value={
                        getUnSavedNoticeDetails["vat"] === undefined
                          ? Vats[2]
                          : Vats[
                              Vats.findIndex(
                                (f: any) =>
                                  f.value === getUnSavedNoticeDetails["vat"]
                              )
                            ]?.label
                      }
                      onChange={(e) =>
                        SetUnSavedNoticeDetailsInfo({
                          target: { id: "vat", value: e },
                        })
                      }
                    />
                    {/* <Input
                      style={{ width: "610px", height: "40px" }}
                      onKeyDown={handleKeyDown}
                      id="SetUnSavedNoticeDetailsInfo"
                      name="vat"
                      onChange={SetUnSavedNoticeDetailsInfo}
                      value={
                        getUnSavedNoticeDetails["vat"] === undefined
                          ? parseFloat("10")
                          : parseFloat(getUnSavedNoticeDetails["vat"]) * 100
                      }
                      className="p-2"
                      placeholder=""
                    /> */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="display-flex align-items-center my-2 mt-2">
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    مقدار
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      style={{ width: "610px", height: "40px" }}
                      onKeyDown={handleKeyDown}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      id="count"
                      name="count"
                      onChange={SetUnSavedNoticeDetailsInfo}
                      value={
                        getUnSavedNoticeDetails["count"] === undefined
                          ? ""
                          : getUnSavedNoticeDetails["count"]
                      }
                      className="p-2"
                      placeholder="مقدار"
                      onBlur={(e) => {
                        if (
                          e.target.value === "0" ||
                          e.target.value === "" ||
                          e.target.value.trim() === ""
                        ) {
                          setCountIsValid(false);
                          e.target.focus();
                        } else {
                          setCountIsValid(true);
                        }
                      }}
                      status={getCountIsValid ? "" : "error"}
                      onPaste={handlePaste}
                    />
                  </Col>
                </Row>
              </Col>

              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    واحد{" "}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Select
                      onKeyDown={handleKeyDown}
                      style={{ width: 610, height: "40px" }}
                      //onChange={handleChange}

                      options={Units}
                      defaultValue="1"
                      id="unit"
                      value={
                        getUnSavedNoticeDetails["unit"] === undefined
                          ? Units[0]
                          : Units[
                              Units.findIndex(
                                (f: any) =>
                                  f.value === getUnSavedNoticeDetails["unit"]
                              )
                            ]?.label
                      }
                      onChange={(e) =>
                        SetUnSavedNoticeDetailsInfo({
                          target: { id: "unit", value: e },
                        })
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="display-flex align-items-center my-2 mt-2">
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    آدرس انتخابی{" "}
                  </Col>
                </Row>
                <Row style={{ width: "100%" }}>
                  <Col style={{ width: "100%" }}>
                    <Select
                      onKeyDown={handleKeyDown}
                      style={{ width: "610px", height: "40px" }}
                      placeholder="انتخاب از آدرس های من"
                      options={getMyAddresses}
                      value={
                        getUnSavedNoticeDetails["addressId"] === undefined
                          ? Units[0]
                          : Units[
                              Units.findIndex(
                                (f: any) =>
                                  f.value ===
                                  getUnSavedNoticeDetails["addressId"]
                              )
                            ]?.label
                      }
                      onChange={(e) =>
                        SetUnSavedNoticeDetailsInfo({
                          target: { id: "addressId", value: e },
                        })
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col style={{ margin: "auto" }}>
                <Row style={{ height: "37px" }}>
                  <Col
                    style={{
                      fontFamily: "YekanBakhVF",
                      fontWeight: "325",
                      fontSize: "16px",
                      lineHeight: "28.8px",
                      color: ColorPalette.gray[950],
                    }}
                  >
                    توضیحات
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      style={{ width: "610px", height: "40px" }}
                      onKeyDown={handleKeyDown}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      id="desc"
                      name="desc"
                      disabled
                      className="p-2"
                      placeholder="توضیحات"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Row
            className="mt-4"
            style={{
              height: "50px",
              backgroundColor: "white",
              marginTop: "10px",
              paddingBottom: "30px",

              border: "1px dotted",
              borderColor: ColorPalette.gray[500],
              borderRadius: "4px",
            }}
          >
            <Col style={{ margin: "auto" }}>
              <CustomButton
                onClick={() => handleAddNoticeDetailAndAddNewRow(0)}
                customType="Text"
                hasTitle
                RightIcon={TedWhitePlus}
                RightIconEnabled
                customSize="XLarge"
                style={{ width: "80rem" }}
              >
                افزودن کالا
              </CustomButton>
            </Col>
          </Row>

          <Row className="display-flex">
            <Col sm={20} md={20} lg={20} xl={20}>
              <Card className="my-3">
                <Typography.Title level={5}>فرآیند آگهی</Typography.Title>

                <div className="col-12 mt-2">
                  <div className="col-lg-3  col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
                    <Input
                      className="w-100 iran mx-1"
                      onBlur={(e) => {
                        if (e.target.value === "") {
                          setNoticeLevelIsValid(false);
                          e.target.focus();
                        } else {
                          setNoticeLevelIsValid(true);
                        }
                      }}
                      status={getNoticeLevelIsValid ? "" : "error"}
                      onChange={SetSelectedNoticeLevelInfo}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          addNoticeLevel(0);
                        }
                      }}
                      id="noticeLevelName"
                      name="noticeLevelName"
                      placeholder="فرآیند"
                      value={
                        GetSelectedNoticeLevels["noticeLevelName"] === undefined
                          ? ""
                          : GetSelectedNoticeLevels["noticeLevelName"]
                      }
                    />
                    <PlusSquareOutlined
                      onClick={() => addNoticeLevel(0)}
                      style={{ color: "green", fontSize: "1.5rem" }}
                    />
                  </div>
                </div>
                <hr />
                {GetNoticeLevels?.sort(dynamicSort("order"))
                  .reverse()
                  .map((p: any) => (
                    <div className="col-12 mt-2" key={(p as any).id}>
                      <div className="col-lg-3   col-xs-12  d-md-inline-flex d-sm-block d-xs-inline-block">
                        <Input
                          className="w-100 iran mx-1"
                          disabled
                          value={p.level}
                        />
                      </div>

                      <div className="col-lg-2  col-xs-12 d-md-inline-flex d-sm-block d-xs-inline-block">
                        <Tooltip title="حذف">
                          <Popconfirm
                            title="آیا از حذف ردیف مطمئن هستید؟"
                            okText="بله"
                            cancelButtonProps={{
                              className: "ant-btn-primary ant-btn-dangerous",
                              style: {
                                color: "black",
                              },
                            }}
                            cancelText="خیر"
                            onConfirm={() => removeNoticeLevel(p.id)}
                          >
                            <a>
                              <DeleteFilled />
                            </a>
                          </Popconfirm>
                        </Tooltip>
                      </div>
                    </div>
                  ))}
              </Card>

              <Card className="p-1">
                {GetNoticeCoverView === null ? (
                  <>
                    <input
                      accept="image/*"
                      onChange={handleCapture}
                      style={{ display: "none" }}
                      id="raised-button-file"
                      type="file"
                    />
                    <label>
                      <Button
                        onClick={() =>
                          document.getElementById("raised-button-file")?.click()
                        }
                        icon={<CameraOutlined />}
                      >
                        انتخاب کاور آگهی
                      </Button>
                    </label>
                  </>
                ) : (
                  <>
                    <img
                      style={{ height: "120px", width: "120px" }}
                      src={GetNoticeCoverView}
                    />
                    <Button
                      onClick={() => {
                        SetNoticeCover(null);
                        SetNoticeCoverView(null);
                        ImageUpload(null);
                      }}
                      icon={<DeleteOutlined />}
                    />
                  </>
                )}
              </Card>

              <Card title="فایل های پیوست" className="p-1 my-3">
                <div
                  style={{
                    backgroundColor: "transparent",
                    textAlign: "center",
                  }}
                >
                  <div
                    className="mx-2"
                    style={{
                      display: "inline-flex",
                    }}
                  >
                    {File1 === null ? (
                      <>
                        <input
                          accept="*"
                          onChange={(e) => SetFile1((e as any).target.files[0])}
                          style={{ display: "none" }}
                          id="file1"
                          type="file"
                        />
                        <label>
                          <Button
                            onClick={() =>
                              document.getElementById("file1")?.click()
                            }
                            style={{ height: "100px", width: "100px" }}
                            icon={<PaperClipOutlined />}
                          />
                        </label>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  {FileLoadedView?.map((p: any) => {
                    return (
                      <>
                        <Tooltip title="حذف">
                          <Popconfirm
                            title="آیا از حذف این پیوست اطمینان دارید ؟"
                            okText="بله"
                            cancelButtonProps={{
                              className: "ant-btn-primary ant-btn-dangerous",
                              style: {
                                color: "black",
                              },
                            }}
                            cancelText="خیر"
                            onConfirm={() =>
                              DeleteFileById({ id: p.id }).then(() => {
                                GetFilesAsync(getNoticeId);
                              })
                            }
                          >
                            <a className="px-2" style={{ border: "1px" }}>
                              <DeleteOutlined style={{ color: "red" }} />
                            </a>
                          </Popconfirm>
                        </Tooltip>

                        <div
                          className="mx-2"
                          style={{
                            display: "inline-flex",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            accept="*"
                            disabled
                            style={{ display: "none" }}
                            id={p.id}
                            type="file"
                          />
                          <label htmlFor={p.id}>
                            <Button
                              onClick={() => handleDownload(p.id, p.name)}
                              style={{
                                height: "100px",
                                width: "100px",
                                cursor: "pointer",
                              }}
                            >
                              {p.name.substring(0, 10)}
                            </Button>
                          </label>
                        </div>
                      </>
                    );
                  })}
                </div>
              </Card>

              <Flex justify="center">
                <CustomButton
                  style={{
                    width: "196px",
                    height: "48px",
                    border: "1px solid",
                    backgroundColor: ColorPalette.primaryBlue[50],
                    borderColor: ColorPalette.primaryBlue[600],
                    color: ColorPalette.primaryBlue[600],
                  }}
                  hasTitle
                  customType="Secondary"
                  disabled={getNoticeDetails.length < 3}
                  onClick={async (e) =>
                    await ChangeContentAsync({
                      key: "noticestate",
                      value: "2",
                    }).then(() => navigate("/Dashboard"))
                  }
                >
                  ثبت آگهی
                </CustomButton>
                <CustomButton
                  style={{
                    marginRight: "10px",
                    width: "196px",
                    height: "48px",
                    border: "1px solid",
                    backgroundColor: ColorPalette.primaryBlue[50],
                    borderColor: ColorPalette.primaryBlue[600],
                    color: ColorPalette.primaryBlue[600],
                  }}
                  hasTitle
                  customType="Secondary"
                  disabled={getNoticeDetails.length < 3}
                  onClick={async (e) =>
                    await ChangeContentAsync({
                      key: "noticestate",
                      value: "1",
                    }).then(() => navigate("/Dashboard"))
                  }
                >
                  ذخیره در پیش نویس ها
                </CustomButton>
              </Flex>
            </Col>
          </Row>
          <Row style={{ height: "200px" }}></Row>
        </>
      )}
    </div>
  );
};

export default ManageNoticeV3;
